import { CommonModule } from '@angular/common';
import { MonthlyRevenuesPerItemRoutingModule } from './monthly-revenues-per-item-routing.module';
import { NgModule } from '@angular/core';
import { TableModule } from '@coreui/angular';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TableModule,
    MonthlyRevenuesPerItemRoutingModule,
  ]
})
export class MonthlyRevenuesPerItemModule { }
